var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPengeluaran2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#FEE4E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.333 26.6667V23.3333C48.333 21.495 46.838 20 44.9997 20H23.333C20.5763 20 18.333 22.2433 18.333 25V45C18.333 48.6683 21.323 50 23.333 50H48.333C50.1713 50 51.6663 48.505 51.6663 46.6667V30C51.6663 28.1617 50.1713 26.6667 48.333 26.6667ZM44.9997 41.6667H41.6663V35H44.9997V41.6667ZM23.333 26.6667C22.9039 26.6475 22.4987 26.4635 22.2018 26.153C21.9049 25.8426 21.7392 25.4296 21.7392 25C21.7392 24.5704 21.9049 24.1574 22.2018 23.847C22.4987 23.5365 22.9039 23.3525 23.333 23.3333H44.9997V26.6667H23.333Z",
    fill: "#B42318"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 43C15 49.6274 20.3726 55 27 55C33.6274 55 39 49.6274 39 43C39 36.3726 33.6274 31 27 31C20.3726 31 15 36.3726 15 43ZM28.0607 48.5607L32.5607 44.0607C33.1464 43.4749 33.1464 42.5251 32.5607 41.9393C31.9749 41.3536 31.0251 41.3536 30.4393 41.9393L28.5 43.8787L28.5 38.5C28.5 37.6716 27.8284 37 27 37C26.1716 37 25.5 37.6716 25.5 38.5L25.5 43.8787L23.5607 41.9393C22.9749 41.3536 22.0251 41.3536 21.4393 41.9393C20.8536 42.5251 20.8536 43.4749 21.4393 44.0607L25.9393 48.5607C26.5251 49.1464 27.4749 49.1464 28.0607 48.5607Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPengeluaran2);
export default __webpack_public_path__ + "static/media/pengeluaran-2.ea1aa5f2513e9383e6663357a7666783.svg";
export { ForwardRef as ReactComponent };